import { Select, SelectOption } from '../../../components';
import { ConversationFilter as FilterType } from '../../../types';
import { useConversationStore } from '../../../stores';
import { useMultipleWhatsAppNumbers } from '../hooks/useWhatsAppNumbers';

const filterOptions: SelectOption[] = [
  { value: 'all', label: 'All Conversations' },
  { value: 'assigned_to_me', label: 'Assigned to Me' },
  { value: 'unassigned', label: 'Unassigned' },
  { value: 'bot_active', label: 'Bot Active' },
  { value: 'staff_active', label: 'Staff Active' },
  { value: 'resolved', label: 'Resolved' },
  { value: 'negative_sentiment', label: 'Negative Sentiment' },
  { value: 'high_priority', label: 'High Priority' },
  { value: 'voice_calls', label: 'Voice Calls' },
];

const ALL_NUMBERS = '__all__';

export default function ConversationFilter() {
  const { filter, setFilter, numberFilter, setNumberFilter } = useConversationStore();
  // Only a store with more than one WhatsApp number gets the number filter.
  const numbers = useMultipleWhatsAppNumbers();

  const select = (
    <Select
      value={filter}
      onChange={(value) => setFilter(value as FilterType)}
      options={filterOptions}
      placeholder="Filter conversations"
    />
  );
  if (!numbers.length) return select;

  const numberOptions: SelectOption[] = [
    { value: ALL_NUMBERS, label: 'All numbers' },
    ...numbers
      .filter((n) => n.id)
      .map((n) => ({
        value: n.id as string,
        label: n.label || n.displayNumber || n.phoneNumberId,
      })),
  ];

  return (
    <div className="grid grid-cols-2 gap-2">
      {select}
      <Select
        value={numberFilter?.id ?? ALL_NUMBERS}
        onChange={(value) => {
          const n = numbers.find((x) => x.id === value);
          setNumberFilter(n && n.id ? { id: n.id, isDefault: n.isDefault } : null);
        }}
        options={numberOptions}
        placeholder="Number"
      />
    </div>
  );
}
